import React from 'react';

const About = () => {
  return (
    <div>
      {/* Hero */}
      <section className="bg-primary text-white section-padding">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Notre Histoire</h1>
          <p className="text-xl opacity-90">La passion du chocolat belge</p>
        </div>
      </section>
      
      {/* Story */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-4xl font-bold text-primary">
                Des <span className="text-accent">Pétales</span> de Passion
              </h2>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                Pétales de Douceur est née de l'amour pour le chocolat 
                et le désir de créer des moments uniques de bonheur. 
                Notre artisanat combine tradition et innovation pour 
                vous offrir des créations exceptionnelles.
              </p>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                Nous utilisons uniquement du chocolat belge de bonne qualité, 
                sélectionné avec soin pour ses arômes exceptionnels. Chaque 
                produit est conçu en respectant les méthodes artisanales 
                qui font la renommée de notre chocolat.
              </p>
            </div>
            
            <div className="bg-secondary rounded-3xl p-8">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="aspect-square">
                  <img 
                    src="/images/About_assets/vue_globale_ptldd.jpeg"
                    alt="Vue globale de notre atelier d'artisanat"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Values */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-primary mb-4">Nos Valeurs</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Les principes qui guident chaque création
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: "fas fa-leaf",
                title: "Qualité",
                desc: "Chocolat belge d'exception"
              },
              {
                icon: "fas fa-heart",
                title: "Passion",
                desc: "Amour du métier dans chaque création"
              },
              {
                icon: "fas fa-hand-sparkles",
                title: "Artisanat",
                desc: "Fabrication artisanale "
              },
              {
                icon: "fas fa-smile",
                title: "Plaisir",
                desc: "Créer des moments de bonheur"
              }
            ].map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300 card-hover">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-3xl text-primary`}></i>
                </div>
                <h3 className="text-2xl font-bold text-dark mb-3">{value.title}</h3>
                <p className="text-gray-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;